import { staticText } from '../../../utils/translations/staticText';

export const TRANSLATIONS = staticText({
  google_ratings: {
    _: ':count Google rating|:count Google ratings',
    zh: ':count 則 Google 評分|:count 則 Google 評分',
  },
  view_reviews: {
    _: 'See reviews on Google',
    zh: '查看 Google 評論',
  },
});
